import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

interface SearchProps {
  haveResults?: boolean;
}
export const Container = styled.div<SearchProps>`
  display: flex;
  max-height: 200px;
  width: 100%;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const ShowOptions = styled.div<SearchProps>`
  display: flex;
  position: absolute;
  background: #fff;
  width: 100%;
  flex-direction: column;
  z-index: 9;
  border: none;
  border-top: none;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.161);
`;

export const Title = styled.div`
  font-size: 24px;
  color: #1a1b1c;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const WarningText = styled.h2`
  font-style: normal;
  display: flex;
  flex-direction: row;
  font-weight: normal;
  font-size: 14px;

  color: ${beam.font.error};
`;
export const Text = styled(WarningText)`
  color: ${beam.font.primary};
  width: fit-content;
  white-space: nowrap;
  margin-left: 8px;
`;
export const ButtonText = styled(WarningText)`
  color: ${beam.font.link};
  margin-left: 14px;
  cursor: pointer;
`;
export const WarningBoldText = styled(WarningText)`
  font-weight: bold;
`;
export const HeadRight = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
`;
export const HeadLeft = styled(HeadRight)`
  justify-content: flex-start;
`;
export const Button = styled.button`
  background: #1371fe;
  color: #fff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
  font-weight: 500;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  margin-left: 24px;
  :disabled {
    opacity: 0.3;
  }
`;
export const Icon = styled.img`
  margin-right: 8px;
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  flex: 1;
`;
export const Div = styled.div<SearchProps>`
  position: relative;
  flex-direction: column;
  display: flex;
  width: 100%;
  border: none;
`;

export const Search = styled.div<SearchProps>`
  color: ${beam.font.primary};
  box-sizing: border-box;
  /* borders/light-border */
  flex: 1;
  width: 100%;
  :disabled {
    cursor: default;
  }
  font-family: 'Poppins', sans-serif;

  color: ${beam.font.primary};

  border: none;

  cursor: ${({ haveResults }) => (!haveResults ? 'pointer' : 'pointer')};
  display: flex;
  align-items: center;

  color: ${beam.font.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;

  margin-bottom: 0;
  white-space: nowrap;
`;
interface SearchImgProps {
  isDisabled?: boolean;
}
export const SearchImg = styled.img<SearchImgProps>`
  left: 12px;
  position: absolute;
  z-index: 1;
  margin-right: -10px;
  margin-top: -5px;
  visibility: ${({ isDisabled }) => (isDisabled ? 'hidden' : 'visible')};
`;

export const Line = styled.div`
  border-top: 1px solid #e9edf1;
  width: auto;
  display: flex;
  position: absolute;
  bottom: 0;
  margin-left: 16px;
`;

export const Count = styled.div`
  color: #1a1b1c;
  margin-left: 16px;
`;
export const SearchButton = styled.h1`
  color: ${beam.color.primaryBlue};
  right: 6px;
  position: absolute;
  font-weight: 500;
  font-style: normal;
  font-size: 12px;
  margin-right: 5px;
  white-space: nowrap;
  cursor: pointer;
  margin-bottom: 0;
`;
export const Close = styled.img`
  cursor: pointer;
  margin-left: -21px;
  margin-right: 7px;
`;
export const LoadingImg = styled.img`
  height: 20px;
  width: 20px;
  margin-left: -25px;
  margin-right: 5px;
`;

export const StyledOption = styled.text`
  display: flex;
  user-select: none;
  width: 100%;
  color: ${beam.font.primary};
  align-items: flex-start;
  margin-top: 8px;
  white-space: nowrap;
  padding-left: 8px;
  justify-content: flex-start;
  text-align: start;
  cursor: pointer;

  color: ${beam.font.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;

  margin-bottom: 0;
  :hover {
    background: ${beam.background.hover};
  }
`;
export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 8px;
  margin-right: 8px;
  margin-top: 8px;
`;

export const BlueButton = styled.button`
  color: ${beam.color.primaryBlue};
  font-size: 14px;
  font-style: normal;

  white-space: nowrap;
  background: none;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  background: transparent;
  border-radius: 8px;
`;
